import axios from "axios";
import queryString from "query-string";
import { store } from "../redux/store";

//const getBaseDomain = () => {
//    const hostnameParts = window.location.hostname.split('.');
//    // Handle different domain depths (e.g., cards.live-let.com → live-let.com)
//    const baseDomain = hostnameParts.slice(-2).join('.'); // ['live-let', 'com']  
//    return `https://${baseDomain}:8008`;
//};

const apiURL = import.meta.env.VITE_API_URL + "/capi";
//const apiURL = "/capi";

// config axios
const axiosClient = axios.create({
    baseURL: apiURL,
    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },

    paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use(
    (config) => {
        const state = store.getState();
        const user = state.user.data;

        //console.log("user in interceptors", user);
        if(!user) return config;

        const { userKey, userToken, companyKey } = user;
        if(!userKey || !userToken || !companyKey) return config;

        if (!config.data) {
            config.data = {externalUserKey: userKey, userToken: "7e16b5527c77ea58", companyKey: 2, companyApiKey: "09df728269"};
        } else if (config.data instanceof FormData) {
            config.data.append("externalUserKey", userKey.toString());
            config.data.append("userToken", "7e16b5527c77ea58");
            config.data.append("companyKey", "2");
            config.data.append("companyApiKey", "09df728269");
        } else if (typeof config.data === 'object') {
            config.data = {...config.data, externalUserKey: userKey, userToken: "7e16b5527c77ea58", companyKey: 2, companyApiKey: "09df728269"};
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosClient.interceptors.response.use(
    (response) => {
        if (response && response.data) {
            return response.data;
        }
        return response;
    },
    (error: any) => {
        if (error.response && error.response.status === 401) {
            // handle logout
        }
        return Promise.reject(error);
    }
);

export default axiosClient;
